export const REPORT_TABS = {
  OVERVIEW: 'overview',
  FUNNEL: 'funnel',
  FLOW: 'flow',
  DIMENSION: 'dimension',
};

export const REPORT_TAB_ORDER = [
  REPORT_TABS.OVERVIEW,
  REPORT_TABS.FUNNEL,
  REPORT_TABS.DIMENSION,
  REPORT_TABS.FLOW,
];

// Tabs that reference specific steps or per-funnel configuration, and therefore require a
// single funnel to be selected.
export const BOARD_SCOPED_TABS = [
  REPORT_TABS.FUNNEL,
  REPORT_TABS.DIMENSION,
  REPORT_TABS.FLOW,
];

// Dimensions every funnel has without any configuration: the card's origin, the products
// on it and the reason it was lost. Label axes come from the funnel's own settings.
export const BUILT_IN_DIMENSIONS = ['source', 'product', 'lost_reason'];
export const DEFAULT_DIMENSION = 'source';

// Any custom attribute of the card or of its primary contact is also an axis; dates group by week, month or year.
export const CUSTOM_ATTRIBUTE_DIMENSION = 'custom_attribute';
export const ATTRIBUTE_DIMENSION_MODELS = [
  'task_attribute',
  'contact_attribute',
];
export const DIMENSION_DATE_GROUPS = ['week', 'month', 'year'];
export const DEFAULT_DIMENSION_DATE_GROUP = 'month';
// Row key the server uses for the texts beyond the ten most frequent.
export const DIMENSION_OTHER_KEY = '__other__';

export const TIMESERIES_METRICS = [
  'throughput',
  'deals_won',
  'deals_lost',
  'deals_created',
];
export const DEFAULT_TIMESERIES_METRIC = 'throughput';

export const TIMESERIES_GROUP_BY = ['day', 'week', 'month'];
export const DEFAULT_GROUP_BY = 'day';

// The CFD reuses the same day/week/month granularity as the throughput chart.
export const CFD_GROUP_BY = TIMESERIES_GROUP_BY;
export const DEFAULT_CFD_GROUP_BY = 'day';

export const DEFAULT_RANGE_DAYS = 30;

export const ALL_BOARDS_VALUE = 'all';
export const ALL_AGENTS_VALUE = 'all';
export const ALL_INBOXES_VALUE = 'all';

// Reports downloadable as CSV per tab. `report` is the API endpoint segment; `labelKey`
// is an i18n key under KANBAN.REPORTS for the export menu entry.
export const EXPORTABLE_REPORTS = {
  [REPORT_TABS.OVERVIEW]: [
    { report: 'summary', labelKey: 'EXPORT.SUMMARY' },
    { report: 'timeseries', labelKey: 'THROUGHPUT.TITLE' },
    { report: 'agent_performance', labelKey: 'LEADERBOARD.TITLE' },
  ],
  [REPORT_TABS.FUNNEL]: [{ report: 'funnel', labelKey: 'FUNNEL.TITLE' }],
  [REPORT_TABS.DIMENSION]: [
    { report: 'dimension', labelKey: 'DIMENSION.TITLE' },
  ],
  [REPORT_TABS.FLOW]: [
    { report: 'cfd', labelKey: 'CFD.TITLE' },
    { report: 'aging', labelKey: 'AGING.TITLE' },
    { report: 'stage_durations', labelKey: 'DURATIONS.TITLE' },
  ],
};

// Lista de cartoes: entrada do menu de exportacao em todas as abas (com ou sem funil), so para quem gerencia
// relatorios. O arquivo vem do servidor; Excel e o padrao porque abre direto com datas e numeros tipados.
export const TASK_LIST_EXPORT = 'tasks_export';
export const DEFAULT_TASK_LIST_FORMAT = 'xlsx';

// Primary bar color for time-series charts, matching the brand blue the native Chatwoot
// reports use for their charts so the report surface stays visually consistent.
export const CHART_PRIMARY_COLOR = 'rgb(31, 147, 255)';

// Categorical palette for the dimension ring. Validated for colour-vision deficiency in
// this order -- reordering the entries breaks the adjacent-pair separation, so add new
// hues at the end rather than inserting. Every slice is also named in the legend with its
// value, so identity never rests on colour alone.
export const DIMENSION_SLICE_COLORS = [
  '#2563EB',
  '#D97706',
  '#DB2777',
  '#65A30D',
  '#7C3AED',
  '#0891B2',
];

// Two series only: the selected period reads as the subject, the previous one recedes.
export const DIMENSION_COMPARE_COLORS = {
  current: '#2563EB',
  previous: '#94A3B8',
};

// Beyond this the ring turns into slivers; the rest collapses into one "Others" slice.
export const DIMENSION_MAX_SLICES = 6;

// Used when a step has no color so charts/legends stay legible.
export const FALLBACK_STEP_COLORS = [
  '#3B82F6',
  '#8B5CF6',
  '#EC4899',
  '#F59E0B',
  '#10B981',
  '#06B6D4',
  '#EF4444',
  '#64748B',
];

export const stepColor = (color, index) =>
  color || FALLBACK_STEP_COLORS[index % FALLBACK_STEP_COLORS.length];
